const plugins = [];
var injectedPlugins_default = plugins;
export {
  injectedPlugins_default as default
};
